import { useIsAuthenticated } from '@heidi/auth/state';
import { skipToken, useQuery } from '@tanstack/react-query';

import { GET_NOTIFICATION_PREFERENCES } from '../../contracts/keys';
import { getNotificationPreferences } from '../api/notification-preferences';
import { getWorkspaceDataConfig } from '../config';
import { useQueryUser } from './useQueryUser';

export const invalidateNotificationPreferences = () =>
  getWorkspaceDataConfig().queryClient.invalidateQueries({
    queryKey: [GET_NOTIFICATION_PREFERENCES],
  });

export const useQueryNotificationPreferences = () => {
  const { isAuthenticated } = useIsAuthenticated();
  const { data: user } = useQueryUser();
  return useQuery({
    enabled: !!user && isAuthenticated,
    queryKey: [GET_NOTIFICATION_PREFERENCES],
    queryFn: isAuthenticated
      ? async () => {
          const { data } = await getNotificationPreferences();
          return data;
        }
      : skipToken,
  });
};
